<template>
  <div class="open-type">
    <Progress progress="10"></Progress>
    <div class="list">
      <div class="item" v-for="(item, index) in typeList" :key="index">
        <img :src="item.icon" class="icon" />
        <div class="info">
          <p class="title">{{ item.title }}</p>
          <p class="sub">{{ item.sub }}</p>
        </div>
        <img src="@/assets/images/arrow-right.png" class="arrow">
      </div>
    </div>
  </div>
</template>

<script>
import Progress from "../components/Progress.vue";
import CHINAICON from "@/assets/images/icon_modechoose_china.png";
import OTHERICON from "@/assets/images/icon_modechoose_other.png";
export default {
  name: "OpenType",
  components: {
    Progress
  },
  data() {
    return {
      typeList: [
        {
          icon: CHINAICON,
          title: "中国大陆居民",
          sub: "内地居民身份证",
          path: ""
        },
        { icon: OTHERICON, title: "其他地区用户", sub: "护照", path: "" }
      ]
    };
  }
};
</script>

<style scoped lang="less">
.open-type {
  padding-top: 62px;
  .list{
    margin-top: 40px;
    padding: 0 32px;
    .item{
      background: #F6F7FA;
      border-radius: 24px;
      padding: 56px 32px;
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .icon{
        width: 88px;
        height: 88px;
      }
      .info{
        height: 70px;
        flex: 1;
        margin: 0 16px;
        display: flex;
        line-height: 1;
        flex-direction: column;
        justify-content: space-between;
        .title{
          font-weight: 500;
          font-size: 32px;
          color: #17161C;
        }
        .sub{
          font-size: 28px;
          color: #747377;
        }
      }
      .arrow{
        width: 48px;
        height: 48px;
      }
    }
  }
}
</style>
